
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Features from './components/Features';
import Applications from './components/Applications';
import Strengths from './components/Strengths';
import Products from './components/Products';
import News from './components/News';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <Features />
      <Applications />
      <Strengths />
      <Products />
      <News />
      <CTA />
      <Footer />
    </div>
  );
}
